import { deep } from "@theme-ui/presets";

export default {
  ...deep, // 继承深色主题
  colors: {
    ...deep.colors,
    background: "#121212", // 纯黑背景
    text: "#ffffff", // 文字颜色
    primary: "#1DB954", // 主要颜色（比如按钮）
    secondary: "#535353", // 次要颜色
  },
};
